/**
 * `**bold**` inside a string of instructions.
 *
 * The install guide and the notification settings both name buttons the reader
 * has to find on their own device — "tap **Share**" — and a sentence that
 * cannot emphasise the button's name makes them hunt for it. Written as one
 * string per step rather than JSX so `lib/install.ts` stays data.
 *
 * Shared because it was private to MobileOnboarding and the settings screen
 * needed the same thing; two copies of a markup rule drift.
 */
export function Emphasised({ text }: { text: string }) {
  return (
    <>
      {text.split(/\*\*(.+?)\*\*/g).map((part, i) =>
        i % 2 === 1 ? <strong key={i} className="font-semibold text-foreground">{part}</strong> : part,
      )}
    </>
  )
}
